<footer class="footer-layout">
  <div class="container">
    <div class="row d-flex align-items-center text-md-left text-center">
      <section class="col-sm-12 col-md-5 col-lg-4">
        <h5 class="title margin">Ubicaci&oacute;n</h5>
        <span class="content">
          <ul class="list-unstyled">
            <li>
              <p>
                <a class="link pointer link" style="-webkit-appearance: none; -moz-appearance: none; appearance: none;" href="{{wazeUrl}}" target="_blank" type="button" role="button">Ir por Waze</a>
              </p>
            </li>
            <li>
              <p>
                <a class="link pointer link" style="-webkit-appearance: none; -moz-appearance: none;appearance: none;" href="{{googleMapsUrl}}" target="_blank" type="button" role="button">Ir por Google maps</a>
              </p>
            </li>
            <li>
              <p class="pt-1">Calle Loa #36 - Anc&oacute;n 15123</p>
            </li>
          </ul>
        </span>
        <h5 class="title margin">Cont&aacute;ctanos</h5>
          <p class="content">
            <a href="mailto:comunidadcristianaancla@gmail" class="link"> comunidadcristianaancla@gmail.com</a>
          </p>
        <h5 class="title margin">M&aacute;s acerca de Ancla</h5>
        <span class="content">
          <ul class="list-unstyled">
            <li><p (click)="notAvalibleModal()" class="link pointer">Liderazgo</p></li>
            <li><p (click)="notAvalibleModal()" class="link pointer">Nuestra cultura</p></li>
            <li><p (click)="notAvalibleModal()" class="link pointer">¿En que creemos?</p></li>
          </ul>
        </span>
     </section>

      <section class="col-sm-12 col-md-3 col-lg-3">
        <h5 class="title margin next-step">Siguiente paso</h5>
        <ul class="content list-unstyled">
          <li (click)="notAvalibleModal()" class="link pointer pt-1"><p>Crecer</p></li>
          <li (click)="notAvalibleModal()" class="link pointer"><p>Estudios avanzados</p></li>
          <li (click)="notAvalibleModal()" class="link pointer home-comunity"><p>Comunidades de hogar</p></li>
        </ul>
        <h5 class="title margin">Links &uacute;tiles</h5>
        <ul class="content list-unstyled">
          <li> 
            <p>
              <a href="https://perukidz.org/" class="link" target="_blank">Perukidz</a>
            </p>
          </li>
        </ul>
        <h5 class="title margin">Ministerios</h5>
        <ul class="content list-unstyled">
          <li>
            <p class="link pointer" (click)="notAvalibleModal()">AnclaKids</p>
          </li>
          <li>
            <p class="link pointer" (click)="notAvalibleModal()">Jóvenes Ancla</p>
          </li>
          <li>
            <p class="link pointer" (click)="notAvalibleModal()">Adolescentes Ancla</p>
          </li>
        </ul>
      </section>
      <section class="col-sm-12 col-md-4 col-lg-5">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7811.718852220118!2d-77.1738813493993!3d-11.77494704006888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91067ff4ce9dd779%3A0xe604511ca5b457a2!2sComunidad%20Cristiana%20Ancla!5e0!3m2!1ses!2smx!4v1606324295942!5m2!1ses!2smx"
        width="100%" height="300vh" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </section>
    </div>
  </div>
    <section class="social-media-row py-1">
      <div class="row d-flex align-items-center text-center">
        <a class="box" href="https://www.facebook.com/ccancla" target="_blank">
          <img src="assets/social-media-icons/facebook.png"></a>
        <a class="box" href="https://www.instagram.com/ccancla" target="_blank">
          <img src="assets/social-media-icons/instagram.png"></a>
        <a class="box" href="https://www.youtube.com/?hl=es-419&gl=PE" target="_blank">
          <img src="assets/social-media-icons/youtube.png"></a>
        <a class="box" href="https://open.spotify.com/show/45ocdRqYCoxTMYdTyT1EUm" target="_blank">
          <img src="assets/social-media-icons/spotify.png"></a>
      </div>
    </section>

  </footer>
